var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "creativity-idea-pencil-school-stars_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,52.132l-1.445-0.964c-0.336-0.225-0.773-0.225-1.109,0L35,52.798l-2.445-1.63c-0.336-0.225-0.773-0.225-1.109,0 L29,52.798l-2.445-1.63c-0.336-0.225-0.773-0.225-1.109,0L24,52.132V30h-2v24c0,0.269,0.11,0.521,0.295,0.705l-0.002,0.002l9,9 C31.488,63.902,31.744,64,32,64s0.512-0.098,0.707-0.293l9-9l-0.002-0.002C41.89,54.521,42,54.269,42,54V35h-2V52.132z M26,53.202 l2.445,1.63c0.336,0.225,0.773,0.225,1.109,0L32,53.202l2.445,1.63c0.336,0.225,0.773,0.225,1.109,0L38,53.202l1.43,0.953 L35.586,58h-7.172l-3.844-3.844L26,53.202z M32,61.586L30.414,60h3.172L32,61.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.093,21.287c-0.118-0.362-0.431-0.626-0.808-0.681l-2.898-0.422l-1.297-2.627c-0.336-0.684-1.457-0.684-1.793,0 L11,20.185l-2.898,0.422c-0.377,0.055-0.689,0.318-0.808,0.681c-0.117,0.361-0.02,0.759,0.253,1.024l2.098,2.045L9.15,27.245 c-0.064,0.375,0.09,0.754,0.397,0.978c0.31,0.226,0.718,0.254,1.054,0.076l2.593-1.363l2.593,1.363 c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191c0.308-0.224,0.462-0.603,0.397-0.978l-0.495-2.888 l2.098-2.045C19.112,22.046,19.21,21.648,19.093,21.287z M14.97,23.291c-0.235,0.229-0.343,0.561-0.287,0.885l0.241,1.409 l-1.265-0.665c-0.146-0.077-0.306-0.115-0.466-0.115s-0.319,0.038-0.466,0.115l-1.265,0.665l0.241-1.409 c0.056-0.324-0.052-0.655-0.287-0.885l-1.023-0.997l1.414-0.206c0.326-0.047,0.607-0.252,0.753-0.547l0.633-1.281l0.633,1.281 c0.146,0.295,0.427,0.5,0.753,0.547l1.414,0.206L14.97,23.291z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.067,8.633l-0.619,3.611c-0.064,0.375,0.09,0.754,0.397,0.979c0.31,0.224,0.717,0.253,1.054,0.075l3.242-1.705 l3.242,1.705c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.19c0.308-0.225,0.462-0.604,0.397-0.979 l-0.619-3.611l2.624-2.558c0.272-0.266,0.37-0.663,0.253-1.024c-0.118-0.362-0.431-0.626-0.808-0.681L24.66,3.843l-1.622-3.285 c-0.336-0.684-1.457-0.684-1.793,0l-1.621,3.285L15.998,4.37c-0.377,0.055-0.689,0.318-0.808,0.681 c-0.117,0.361-0.02,0.759,0.253,1.024L18.067,8.633z M20.432,5.746c0.326-0.047,0.607-0.252,0.753-0.547l0.957-1.939L23.1,5.199 c0.146,0.295,0.427,0.5,0.753,0.547l2.14,0.312l-1.549,1.51c-0.235,0.229-0.343,0.561-0.287,0.885l0.365,2.133l-1.914-1.007 c-0.146-0.077-0.306-0.115-0.466-0.115s-0.319,0.038-0.466,0.115l-1.914,1.007l0.365-2.133c0.056-0.324-0.052-0.655-0.287-0.885 l-1.549-1.51L20.432,5.746z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.716,15.063l4.124-4.02c0.272-0.266,0.37-0.663,0.253-1.024c-0.118-0.362-0.431-0.626-0.808-0.681L43.587,8.51 l-2.549-5.163c-0.336-0.684-1.457-0.684-1.793,0L36.696,8.51l-5.698,0.829c-0.377,0.055-0.689,0.318-0.808,0.681 c-0.117,0.361-0.02,0.759,0.253,1.024l4.124,4.02l-0.974,5.676c-0.064,0.375,0.09,0.754,0.397,0.978 c0.31,0.225,0.718,0.254,1.054,0.076l5.097-2.68l5.097,2.68c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191 c0.308-0.224,0.462-0.603,0.397-0.978L45.716,15.063z M43.943,13.998c-0.235,0.229-0.343,0.561-0.287,0.885l0.72,4.197 l-3.769-1.981c-0.146-0.077-0.306-0.115-0.466-0.115s-0.319,0.038-0.466,0.115l-3.769,1.981l0.72-4.197 c0.056-0.324-0.052-0.655-0.287-0.885l-3.049-2.972l4.213-0.613c0.326-0.047,0.607-0.252,0.753-0.547l1.885-3.817l1.885,3.817 c0.146,0.295,0.427,0.5,0.753,0.547l4.213,0.613L43.943,13.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.131,26.224l-2.535-0.368l-1.135-2.298c-0.336-0.684-1.457-0.684-1.793,0l-1.134,2.298l-2.536,0.368 c-0.377,0.055-0.689,0.318-0.808,0.68c-0.117,0.362-0.02,0.76,0.253,1.025l1.836,1.789l-0.434,2.526 c-0.064,0.375,0.09,0.754,0.397,0.978c0.175,0.127,0.381,0.191,0.588,0.191c0.159,0,0.319-0.038,0.466-0.115l2.268-1.192 l2.268,1.192c0.337,0.178,0.745,0.148,1.054-0.075c0.308-0.225,0.462-0.604,0.397-0.979l-0.433-2.526l1.835-1.789 c0.272-0.266,0.37-0.663,0.253-1.025C57.82,26.542,57.508,26.278,57.131,26.224z M54.078,28.653 c-0.235,0.229-0.343,0.561-0.287,0.885l0.179,1.047l-0.939-0.494c-0.146-0.077-0.306-0.115-0.466-0.115s-0.319,0.038-0.466,0.115 l-0.939,0.494l0.18-1.047c0.056-0.324-0.052-0.655-0.287-0.885l-0.761-0.742l1.051-0.152c0.326-0.047,0.607-0.252,0.753-0.547 l0.47-0.952l0.471,0.952c0.146,0.296,0.427,0.5,0.753,0.547l1.051,0.152L54.078,28.653z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,37h2c0-7.168-5.383-13-12-13v2C24.514,26,29,30.935,29,37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,42h2c0-7.047,3.206-13,7-13v-2C38.953,27,35,33.589,35,42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,25h2c0-2.206,1.346-4,3-4v-2C29.243,19,27,21.691,27,25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16c1.654,0,3,1.794,3,4h2c0-3.309-2.243-6-5-6V16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,24v-2c-4.963,0-9,4.486-9,10h2C34,27.589,37.141,24,41,24z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 44,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 39,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 3,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 11,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4,24 2,24 2,26 0,26 0,28 2,28 2,30 4,30 4,28 6,28 6,26 4,26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61,16 59,16 59,18 57,18 57,20 59,20 59,22 61,22 61,20 63,20 63,18 61,18  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,0c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S62.654,0,61,0z M61,4c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1 S61.552,4,61,4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_6_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativity);
export default __webpack_public_path__ + "static/media/Creativity.57ff758c46271af2756dae619677f5fd.svg";
export { ForwardRef as ReactComponent };